import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { asyncGetReport } from "../../../utils/httpRequests";
import { useSelector } from "react-redux";
import moment from "moment";
import { groupBy } from "../../../utils/helpers";
import { BarChart } from "@mui/x-charts";
import { useTheme } from "@mui/material/styles";
import { sum } from "lodash";

function FeedInWeekChart() {
  const theme = useTheme();
  const { token } = useSelector((state: any) => state.auth);
  const [chartData, setChartData] = useState<number[]>([]);

  const getFeeds = async () => {
    const today = moment();

    const resp = await asyncGetReport({
      apiCode: "fos_rpposts",
      token,
      query: {
        tu_ngay: today.clone().startOf("weeks").startOf("days").toISOString(),
        den_ngay: today.clone().endOf("weeks").endOf("days").toISOString(),
      },
    });
    if (resp && resp?.status === 200) {
      const data = resp?.data || [];
      const groupedData = groupBy({
        data,
        callbackMatch: (item) => {
          return moment(item?.date_created).format("DD/MM/YYYY");
        },
      }) as any[];
      const result = {
        T2: 0,
        T3: 0,
        T4: 0,
        T5: 0,
        T6: 0,
        T7: 0,
        CN: 0,
      };
      for (let i = 0; i < groupedData.length; i++) {
        const item = groupedData[i];
        const key: keyof typeof result = moment(item[0]?.date_created).format(
          "dd"
        ) as keyof typeof result;

        result[key] = item?.length || 0;
      }
      setChartData(Object.values(result));
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    getFeeds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "background.paper",
        borderRadius: "10px",
        px: 2,
        py: 2,
      }}
    >
      <Stack gap={1} sx={{ height: "100%" }}>
        <Typography sx={{ textAlign: "center", fontWeight: 600 }}>
          SỐ LƯỢNG BÀI ĐĂNG TRONG TUẦN
        </Typography>
        <Box sx={{ flex: 1, "& > div": { width: "100%", height: "100%" } }}>
          <BarChart
            height={250}
            borderRadius={10}
            resolveSizeBeforeRender
            xAxis={[
              {
                scaleType: "band",
                data: ["T2", "T3", "T4", "T5", "T6", "T7", "CN"],
              },
            ]}
            series={[
              {
                type: "bar",
                color: theme.palette.primary.main,
                label: "Số lượng",
                data: chartData,
              },
            ]}
          />
        </Box>
        <Typography>Tổng số {sum(chartData)}</Typography>
      </Stack>
    </Box>
  );
}

export default FeedInWeekChart;
